/* Copyright (c) 2017 Backpack Health LLC */

import actionTypes from 'redux/actions';
import { types as sessionActionTypes } from 'redux/actions/session';

const initialState = {
  isFetching: false,
  collection: [],
  isDataFetched: false,
  stats: {
    members_joined: {
      all_time: 0,
      within_last_month: 0,
    },
  },
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case sessionActionTypes.LOG_OUT:
      return Object.assign({}, state, {
        stats: initialState.stats,
      });
    case actionTypes.GROUP_STATS_RECEIVED:
    case actionTypes.GROUPS_RECEIVE:
      return _.assign({}, state, action.payload);
    case actionTypes.GROUP_UPDATED:
      const updatedGroup = action.payload.group;
      const collection = state.collection.map(g => (g.id == updatedGroup.id ? updatedGroup : g));
      return _.assign({}, state, {
        collection
      });
    default:
      return state;
  }
}

const selectors = {
  getGroup: state => (state.lists.group.collection[0] || {}),
  getName: (state, languageCode) => {
    const i18nData = state.lists.group.collection.length > 0 ? state.lists.group.collection[0].name : {};

    if (i18nData.i18n) {
      return i18nData.i18n[languageCode] ? i18nData.i18n[languageCode] : i18nData.default;
    } else {
      return '';
    }
  },
  getLogo: state => state.lists.group.collection.length > 0 ? state.lists.group.collection[0].logo : '',
  getTheme: state => state.lists.group.collection.length > 0 ? state.lists.group.collection[0].theme : {},
  getSubdomain: state => state.lists.group.collection.length > 0 ? state.lists.group.collection[0].subdomain : '',
  getCollection: state => state.lists.group.collection,
  getActiveGroup: state => state.lists.group.collection.length > 0 ? state.lists.group.collection[0] : {},
  getIsDataFetched: state => state.lists.group.isDataFetched,
  getIsValidGroup: state => state.lists.group.isDataFetched && state.lists.group.collection.length > 0,
  getStats: state => state.lists.group.stats,
};

export default selectors;
